(() => {
  'use strict';
  if (customElements.get('ofk-local-market-selector')) return;
  const countryLanguages = {
    AD: ['ca'], BG: ['bg'], CY: ['el'], CZ: ['cs'], GR: ['el'], HR: ['hr'],
    HU: ['hu'], LT: ['lt'], LV: ['lv'], PL: ['pl'], RO: ['ro'], SI: ['sl'],
    SK: ['sk'], SM: ['it'], FR: ['fr'], NL: ['nl'], BE: ['fr', 'nl']
  };
  const normalizeLanguage = value => String(value || '').toLowerCase().split('-')[0];
  customElements.define('ofk-local-market-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.details = this.querySelector('details');
      this.country = this.querySelector('[data-local-country]');
      this.language = this.querySelector('[data-local-language]');
      if (!this.details || !this.country || !this.language) return;
      const template = this.querySelector('template[data-local-language-options]');
      const languageSources = template ? template.content.querySelectorAll('option') : this.language.options;
      this.templates = new Map([...languageSources].map(option => [normalizeLanguage(option.value), option.cloneNode(true)]));
      const currentCountry = String(this.dataset.currentCountry || '').toUpperCase();
      if ([...this.country.options].some(option => option.value === currentCountry)) this.country.value = currentCountry;
      this.sync = (countryCode, preferredLanguage) => {
        const code = String(countryCode || '').toUpperCase();
        const allowed = ['en', ...(countryLanguages[code] || [])].filter(locale => this.templates.has(locale));
        const selected = allowed.includes(preferredLanguage) ? preferredLanguage
          : (countryLanguages[code] || []).find(locale => allowed.includes(locale)) || allowed[0];
        this.language.replaceChildren(...allowed.map(locale => this.templates.get(locale).cloneNode(true)));
        if (selected) this.language.value = selected;
      };
      this.sync(currentCountry, normalizeLanguage(this.dataset.currentLanguage));
      this.onCountry = () => this.sync(this.country.value, '');
      this.onPageShow = () => {
        cancelAnimationFrame(this.pageShowFrame);
        this.pageShowFrame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          if ([...this.country.options].some(option => option.value === currentCountry)) this.country.value = currentCountry;
          this.sync(currentCountry, normalizeLanguage(this.dataset.currentLanguage));
        });
      };
      this.onKey = event => {
        if (event.key === 'Escape' && this.details.open) {
          this.details.open = false;
          this.details.querySelector('summary')?.focus();
        }
      };
      this.onOutside = event => { if (!this.contains(event.target)) this.details.open = false; };
      this.country.addEventListener('change', this.onCountry);
      this.addEventListener('keydown', this.onKey);
      document.addEventListener('pointerdown', this.onOutside);
      window.addEventListener('pageshow', this.onPageShow);
      this.dataset.bound = 'true';
    }
    disconnectedCallback() {
      this.country?.removeEventListener('change', this.onCountry);
      this.removeEventListener('keydown', this.onKey);
      if (this.onOutside) document.removeEventListener('pointerdown', this.onOutside);
      if (this.onPageShow) window.removeEventListener('pageshow', this.onPageShow);
      cancelAnimationFrame(this.pageShowFrame);
      delete this.dataset.bound;
    }
  });
})();
